module.exports = require("./bo-CN.js");